import { Injectable } from '@angular/core';
import { SalesWstoCollectionQuery, SalesWstoCollectionQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesWstoCollectionQuery)
@Wrapper(SalesWstoCollectionQueryHandlerBase)
export class SalesWstoCollectionQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
